import React from 'react';
import { useRecoilValue } from 'recoil';
import { List } from 'antd';
import { useTranslation } from 'react-i18next';
import ListViewBuilder from '../../components/ListViewBuilder';
import useCollections from '../hooks/useCollections';
import {
  allCollectionDataState,
  sorterQueryRecoilState,
} from '../../recoil/atoms';
import { CollectionCard } from '../../components/CollectionCard';
import { CollectionModelToCardData } from '../../lib/models/NftModel';

const CollectionsPage = () => {
  const { t } = useTranslation();
  const collectionList = useRecoilValue(allCollectionDataState);
  const sorterQueryState = useRecoilValue(sorterQueryRecoilState);
  const { onLoadMoreCollections, shouldShowLoadMoreButtonC } = useCollections();
  return (
    <div className="collections-page-wrapper">
      <div className="collections-page-header">
        <h4>{t('Collections 🏆')}</h4>
      </div>
      <div className="collections-page-items">
        <ListViewBuilder
          onLoadMore={onLoadMoreCollections}
          showLoadMoreButton={shouldShowLoadMoreButtonC}
          loading={sorterQueryState.inLoadingState}
          items={collectionList.collections}
          renderItem={(collection) => (
            <List.Item>
              <CollectionCard
                collectionCardData={CollectionModelToCardData(collection)}
              />
            </List.Item>
          )}
          showEndMessage={
            !!collectionList.collections &&
            !!collectionList.collections.length &&
            collectionList.hasLoaded &&
            !sorterQueryState.inLoadingState
          }
        />
      </div>
    </div>
  );
};

export default CollectionsPage;
